import { render, staticRenderFns } from "./QuestionsButton.vue?vue&type=template&id=1d4edaa3"
import script from "./QuestionsButton.vue?vue&type=script&lang=js"
export * from "./QuestionsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports